import { PUBLIC_CLOUDINARY_CLOUD_NAME } from "$app/env/public";
import { faviconCdnUrl as buildFaviconCdnUrl } from "@fergmar/contracts/public/favicon";

export const faviconCdnUrl = (slug: string, pathname: string): string =>
	buildFaviconCdnUrl(PUBLIC_CLOUDINARY_CLOUD_NAME, slug, pathname);
